import React from "react";

function LightBulbIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<g clipPath="url(#clip0_2765_66414)">
				<path
					fill="#FFC107"
					d="M12 3.457a.75.75 0 01-.75-.75V.75a.75.75 0 011.5 0v1.957a.75.75 0 01-.75.75zM18.571 6.18a.75.75 0 01-.53-1.281l1.384-1.384a.75.75 0 111.061 1.06L19.102 5.96a.752.752 0 01-.531.22zM23.25 12.75h-1.957a.75.75 0 010-1.5h1.957a.75.75 0 010 1.5zM19.955 20.705a.744.744 0 01-.53-.22l-1.384-1.384a.75.75 0 111.061-1.06l1.384 1.383a.75.75 0 01-.531 1.281zM4.045 20.705a.75.75 0 01-.53-1.281l1.384-1.384a.75.75 0 111.06 1.061l-1.383 1.384a.748.748 0 01-.531.22zM2.707 12.75H.75a.75.75 0 010-1.5h1.957a.75.75 0 010 1.5zM5.429 6.18a.744.744 0 01-.53-.22L3.515 4.576a.75.75 0 111.06-1.061L5.96 4.899a.75.75 0 01-.531 1.28zM19 12c0 2.16-.98 4.16-2.67 5.5-.69.54-1.14 1.25-1.28 2.01-.02-.01-.03-.01-.05-.01H9c-.02 0-.05 0-.07.01-.14-.79-.55-1.48-1.14-1.92-2.18-1.65-3.2-4.35-2.64-7.07.55-2.65 2.7-4.81 5.35-5.36 2.11-.45 4.27.07 5.91 1.4A6.972 6.972 0 0119 12z"
				/>
				<path
					fill="#607D8B"
					d="M15.05 19.51c-.03.17-.05.34-.05.52v2.22c0 .96-.79 1.75-1.75 1.75h-2.5C9.91 24 9 23.36 9 21.96v-1.77c0-.23-.02-.46-.07-.68.02-.01.05-.01.07-.01h6c.02 0 .03 0 .05.01z"
				/>
				<path
					fill="#FFD54F"
					d="M15.75 12.5a.75.75 0 01-.75-.75A2.752 2.752 0 0012.25 9a.75.75 0 010-1.5 4.255 4.255 0 014.25 4.25.75.75 0 01-.75.75z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2765_66414">
					<path fill="#fff" d="M0 0H24V24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default LightBulbIcon;
